import { useMemo, useState } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import stylesectorLayout from "./SectorLayout.module.css";
import { CatalogCard, CatalogSidePanel } from "../../Components/public/Cards";
import { useGetPublicScenes } from "../../api/publicCatalog";

const normalize = value =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

const SectorLayout = () => {
  const { state } = useLocation();
  const { slug } = useParams();
  const navigate = useNavigate();

  const [showSidePanel, setShowSidePanel] = useState(false);
  const [sidepanelData, setSidepanelData] = useState({});
  const [selectedCard, setSelectedCard] = useState(null);

  const { data: publicScenes, isLoading: isLoadingPublicScenes } = useGetPublicScenes();

  const sectorScenes = useMemo(() => {
    const list = Array.isArray(publicScenes) ? publicScenes : [];
    const categoryId = state?.id;
    return list
      .filter(scene => {
        const categories = Array.isArray(scene?.categories) ? scene.categories : [];
        if (categoryId != null && categoryId !== "") {
          return categories.some(category => String(category?.id) === String(categoryId));
        }
        if (slug) {
          return categories.some(category => normalize(category?.name) === normalize(slug));
        }
        return false;
      })
      .slice()
      .sort((a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0));
  }, [publicScenes, state?.id, slug]);

  const handleShowSidePanel = (title, img, description, id) => {
    setSelectedCard(id);
    navigate(`/scene/${id}`);
    if (!isLoadingPublicScenes) {
      setSidepanelData({
        title: title,
        sidepanelImage: img,
        description: description,
        id: id,
      });
    }
  };

  const handleAnywhereClickCloseSidepanel = () => {
    setShowSidePanel(false);
  };

  return (
    <section
      className={stylesectorLayout["sector-layout-main-section"]}
      onclick={handleAnywhereClickCloseSidepanel}
    >
      <aside
        className={`${stylesectorLayout["side-panel"]} ${
          showSidePanel ? stylesectorLayout.togglePanel : ""
        } `}
      >
        <CatalogSidePanel
          setShowSidePanel={setShowSidePanel}
          sidepanelData={sidepanelData}
          showSidePanel={showSidePanel}
          sceneId={state?.id}
        />
      </aside>
      <div
        className={`${stylesectorLayout["sector-layout-card-container"]}  ${
          showSidePanel && stylesectorLayout.show
        }`}
      >
        {sectorScenes.map(item => (
          <CatalogCard
            key={item.id}
            cardId={item.id}
            title={item.title}
            description={item.description}
            img={item.image}
            onclick={() =>
              handleShowSidePanel(
                item?.title,
                item?.image,
                item?.description,
                item?.id
              )
            }
            showSidePanelCard={showSidePanel}
            sectorOrSidepanel={"sector"}
            selectedId={selectedCard}
          />
        ))}
      </div>
    </section>
  );
};

export default SectorLayout;
